import React, { Component } from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import ls from 'local-storage';
import { LS_MENU_COLLAPSED_KEY } from '../Dashboard';
// it temp solution, to see how it works!
// @see https://redmine.711media.de/issues/26223

class RecordingsPlayer extends Component {
  constructor(props) {
    super(props);
    this.playerRef = React.createRef();
  }

  componentDidMount() {
    this.loadRecordingSnapshot();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.uuid !== this.props.uuid) {
      this.loadRecordingSnapshot();
    }
  }

  loadRecordingSnapshot() {
    this.props.dispatch({
      type: 'leads/loadRecording',
      payload: {
        projectId: this.props.projectId,
        uuid: this.props.uuid,
      },
    }).then(() => this.updatePlayer());
  }

  updatePlayer() {
    this.playerRef.current.innerHTML = '';

    const events = this.props.leads.currentSessionRecording.map((event) => {
      return {
        ...event,
        data: event.data,
        timestamp: new Date(event.timestamp).getTime(),
      };
    });

    // at least two events required
    if (events.length < 2) {
      return;
    }
    const isCollapsed = ls.get(LS_MENU_COLLAPSED_KEY) || false;
    const minusWidth = isCollapsed ? 220 : 0;
    const newWidth = this.playerRef.current.clientWidth - minusWidth;

    // eslint-disable-next-line new-cap,no-new,no-undef
    new rrwebPlayer({
      target: this.playerRef.current, // customizable root element
      data: {
        events,
        autoPlay: false,
        width: newWidth,
        height: 500,
      },
    });
    this.playerRef.current.style.display = 'flex';
    this.playerRef.current.style.justifyContent = 'center';
  }

  render() {
    return <div ref={this.playerRef} />;
  }
}

export default connect(({ leads }) => ({ leads }))(injectIntl(RecordingsPlayer));



// WEBPACK FOOTER //
// ./src/components/RecordingsPlayer/index.js